module.exports = __webpack_public_path__ + "static/media/envelope-icon-yellow.20032ca0.svg";